// Types
import { ListChannelMonetizationMilestones_listChannelMonetizationMilestones } from 'api/channelMonetization/types/ListChannelMonetizationMilestones';
import { SetChannelMonetizationMilestoneTargetsVariables } from 'api/channelMonetization/types/SetChannelMonetizationMilestoneTargets';
import { MilestoneRow, ProgramFormValues } from './types';
import { MONTH_LABEL_PATTERN } from './constants';

export const currentMonthLabel = (date: Date = new Date()): string => {
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${date.getUTCFullYear()}-${month}`;
};

export const toMilestoneRow = (
  milestone: ListChannelMonetizationMilestones_listChannelMonetizationMilestones
): MilestoneRow => ({
  type: milestone.type,
  target: milestone.target,
  enabled: milestone.enabled,
  displayOrder: milestone.displayOrder,
});

export const isValidMonthLabel = (monthLabel: string): boolean =>
  MONTH_LABEL_PATTERN.test(monthLabel);

export const patchMilestoneRows = (
  rows: MilestoneRow[],
  type: MilestoneRow['type'],
  patch: Partial<MilestoneRow>
): MilestoneRow[] =>
  rows.map((row) => (row.type === type ? { ...row, ...patch } : row));

export const buildSetTargetsInput = (
  programId: string,
  milestones: MilestoneRow[]
): SetChannelMonetizationMilestoneTargetsVariables['input'] => ({
  programId,
  targets: milestones.map((row) => ({
    type: row.type,
    target: row.target,
    enabled: row.enabled,
    displayOrder: row.displayOrder,
  })),
});

export const normalizeProgramFormValues = (
  values: ProgramFormValues
): {
  monthLabel: string;
  prizeAmount: number;
  prizeCurrency: string;
  slotsPerMonth: number;
} => ({
  monthLabel: values.monthLabel.trim(),
  prizeAmount: Number(values.prizeAmount),
  prizeCurrency: values.prizeCurrency,
  slotsPerMonth: Number(values.slotsPerMonth),
});
